import { default as React, useState, useContext } from "react";

import { functions } from "../services/firebase";
import { captureError } from "../lib/errorReporting";

const PromotionPlansContext = React.createContext();

export function PromotionPlansProvider({ children }) {
	const [promotionPlans, setPromotionPlans] = useState([]);

	const compare = (a, b) => {
		if (
			a.metadata.duration_in_minutes &&
			b.metadata.duration_in_minutes
		) {
			if (
				parseInt(a.metadata.duration_in_minutes) <
				parseInt(b.metadata.duration_in_minutes)
			) {
				return -1;
			}
			if (
				parseInt(a.metadata.duration_in_minutes) >
				parseInt(b.metadata.duration_in_minutes)
			) {
				return 1;
			}
		}
		return 0;
	};

	const fetchPromotionPlans = async () => {
		try {
			let sortedData = [];

			const { data: response } = await functions.httpsCallable(
				"listOfPromotionPlans"
			)();

			sortedData =
				response.data.length > 0 ? response.data.sort(compare) : [];

			setPromotionPlans(sortedData);
		} catch (err) {
			captureError(err, { action: "fetchPromotionPlans" });
			console.error("Failed to fetch promotion plans", err);
		}
	};

	return (
		<PromotionPlansContext.Provider
			value={{ fetchPromotionPlans, promotionPlans }}
		>
			{children}
		</PromotionPlansContext.Provider>
	);
}

export const usePromotionPlans = () =>
	useContext(PromotionPlansContext);
